/* eslint-disable react/no-array-index-key */
import { Fragment } from 'react';
import { Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useFieldErrors } from '../../hooks/useFieldError';
export function ErrorMessage(props) {
    const { name, id } = props;
    const errors = useFieldErrors(name);
    const hasError = Boolean(errors.length);
    if (!hasError) {
        return null;
    }
    return (<Box id={id} gap="sm" px="md" py="sm" bg="semantic.feedback.danger.surface" borderRadius="md" alignItems="center">
      <Falcon $size={14} $color="semantic.text.danger" icon="circle-exclamation"/>
      <Typography $appearance="danger" $fontSize="tiny">
        {errors.map((error, i) => (<Fragment key={i}>{error}</Fragment>))}
      </Typography>
    </Box>);
}
